import { CheckboxIcon } from '@/assets/icons/Checkbox';

// Public: Render a custom styled checkbox input with label
//
// label - The label content to display next to the checkbox
// id - The unique identifier for the checkbox input
// name - The name attribute for the checkbox input
// required - Whether the checkbox is required for form validation
// checked - The controlled checked state (optional, for controlled component mode)
// onChange - Change handler (optional, for controlled component mode)
//
// Returns a JSX element containing the styled checkbox and label.
export function Checkbox({
  label,
  id,
  name,
  required,
  checked,
  onChange,
}: {
  label: React.ReactNode;
  id: string;
  name: string;
  required?: boolean;
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) {
  return (
    <label className='peer label has-checked:[&_.box]:bg-sh-teal relative flex cursor-pointer gap-2 md:gap-4 has-checked:[&_.box]:border-none has-checked:[&_.check]:block'>
      <input
        name={name}
        type='checkbox'
        required={required}
        checked={checked}
        onChange={onChange}
        className='peer absolute top-1 left-1 size-5 opacity-0'
        id={id}
      />
      <div className='box border-sh-gray bg-sh-gray/25 pointer-events-none relative m-1 inline-flex size-5 shrink-0 items-center justify-center rounded-xs border-2'>
        <CheckboxIcon className='check hidden size-5 text-black' />
      </div>
      <div className='m-0 text-sm'>{label}</div>
    </label>
  );
}
